export default "__VITE_ASSET__DeaZkx5n__"